import React from 'react'
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material'

interface StepComponentProps {
    stepComponent: React.ReactNode
    currentStep: number
    handleBack: () => void
    handleStepChange: () => void
    confirmSubmit: () => void
    handleClose: () => void
    handleConfirm: () => void
    dialogContent: string | React.ReactNode
    dialogTitle: string
    dialogActions: {
        submitLabel: string
    }
    openDialog: boolean
    isStepDisabled: (type: 'back' | 'next') => boolean
    getNextButtonLabel: (currentStep: number) => string
    sx?: object
}

const StepComponent = ({
                           stepComponent,
                           currentStep,
                           handleBack,
                           handleStepChange,
                           confirmSubmit,
                           handleClose,
                           handleConfirm,
                           dialogContent,
                           dialogTitle,
                           dialogActions,
                           openDialog,
                           isStepDisabled,
                           getNextButtonLabel,
                           sx = {
                               borderRadius: '8px',
                               boxShadow: 3,
                               marginX: 'auto',
                               marginTop: 8,
                               width: '95%',
                               maxWidth: '1200px'
                           }
                       }: StepComponentProps) => {
    return (
        <div style={sx as React.CSSProperties}>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-100 px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        {[1, 2, 3].map((step) => (
                            <div
                                key={step}
                                className={`w-8 h-8 rounded-full flex items-center justify-center text-white ${
                                    step === currentStep
                                        ? 'bg-blue-500'
                                        : 'bg-gray-400'
                                }`}>
                                {step}
                            </div>
                        ))}
                        <div className="text-gray-500">
                            Step {currentStep} of 3
                        </div>
                    </div>
                    <div className="flex space-x-2">
                        {currentStep > 1 && (
                            <Button variant="contained" onClick={handleBack} disabled={isStepDisabled('back')}>
                                Back
                            </Button>
                        )}

                        {currentStep === 3 ? (
                            <Box display="flex" justifyContent="flex-end">
                                <Button variant="contained" color="success" onClick={confirmSubmit}>
                                    {dialogActions.submitLabel}
                                </Button>
                            </Box>
                        ) : (
                            <Button
                                variant="contained"
                                onClick={handleStepChange}
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    '&:hover': {
                                        backgroundColor: 'secondary.dark'
                                    }
                                }}
                                disabled={isStepDisabled('next')}>
                                {getNextButtonLabel(currentStep)}
                            </Button>
                        )}
                    </div>
                </div>
                <div className="p-2">
                    {stepComponent}
                </div>
            </div>

            <Dialog open={openDialog} onClose={handleClose}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent>
                    <Typography>{dialogContent}</Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <Button onClick={handleClose} color="error">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default StepComponent
